<div class="call-container">
  <div class="export-container">
    <!-- Buttons Section -->
    <div class="button-group">
      <p-button
        label="{{ 'USER_PAGE.BUTTONS.EXPORT' | translate }}"
        icon="pi pi-download"
        class="p-button-primary export-button"
        (click)="exportCallData()"
      ></p-button>
    </div>
  </div>

  <!-- Search Filters -->
  <div class="search-filters">
    <div class="filter-item cursor-pointer">
      <label for="fromToDate" class="filter-label">{{
        'CALL_PAGE.FILTER_LABELS.FROM_TO_DATE' | translate
      }}</label>
      <p-calendar
        id="fromToDate"
        [(ngModel)]="filters.dateRange"
        selectionMode="range"
        [showButtonBar]="true"
        [readonlyInput]="true"
        placeholder="{{ 'CALL_PAGE.PLACEHOLDERS.SELECT_DATE_RANGE' | translate }}"
        dateFormat="dd-M-yy"
        (ngModelChange)="applyFilters()"
      >
      </p-calendar>
    </div>
    <div class="filter-item">
      <a class="reset-link text-primary" (click)="onResetFilters()">
        {{ 'CALL_PAGE.BUTTONS.RESET' | translate }}
      </a>
    </div>
  </div>

  <!-- Data Table -->
  <p-table
    [value]="callItems.length !== 0 ? callItems : noDataRow"
    [paginator]="callItems.length !== 0 ? true : false"
    [rows]="rows"
    [first]="first"
    [totalRecords]="totalRecords"
    [lazy]="true"
    (onPage)="pageChange($event)"
    (onSort)="sortChange($event)"
    [rowsPerPageOptions]="tableParams.ROW_PER_PAGE"
    sortField="StartTime"
    [sortOrder]="-1"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="StartTime">
          {{ 'CALL_PAGE.CALLS_TABLE.DATE' | translate }}<p-sortIcon field="StartTime"></p-sortIcon>
        </th>
        <th pSortableColumn="Uid">
          {{ 'CALL_PAGE.CALLS_TABLE.CALL_ID' | translate }}<p-sortIcon field="Uid"></p-sortIcon>
        </th>
        <th pSortableColumn="CallerName">
          {{ 'CALL_PAGE.CALLS_TABLE.CALLER' | translate
          }}<p-sortIcon field="CallerName"></p-sortIcon>
        </th>
        <th pSortableColumn="TalkingBuddyName">
          {{ 'CALL_PAGE.CALLS_TABLE.TALKING_BUDDY' | translate
          }}<p-sortIcon field="TalkingBuddyName"></p-sortIcon>
        </th>
        <th pSortableColumn="CallDuration">
          {{ 'CALL_PAGE.CALLS_TABLE.DURATION' | translate
          }}<p-sortIcon field="CallDuration"></p-sortIcon>
        </th>
        <th>{{ 'CALL_PAGE.CALLS_TABLE.ACTION' | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-call>
      <tr *ngIf="callItems?.length !== 0" (click)="onLinkClick(call.id)" class="call-row">
        <td>
          {{ call?.startTime ? (getConvertedDate(call.startTime) | date: 'dd-MMM-YYYY') : '' }}
        </td>
        <td>{{ call.uid }}</td>
        <td>{{ call.callerName }}</td>
        <td>{{ call.talkingBuddyName }}</td>
        <td>{{ formatDuration(call.callDuration) }}</td>
        <td>
          <i class="fa fa-external-link" (click)="onLinkClick(call.id)"></i>
          <i *ngIf="call.hasDispute" class="fa fa-flag flag-icon"></i>
        </td>
      </tr>
      <tr *ngIf="callItems?.length === 0">
        <td colspan="6" class="no-data-available">
          {{ 'COMMON.NO_AVAILABLE' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
